export const auditInfo = {
  isDraft: true,
  auditType: "",
  auditTypeId: "",
  system: [],
  auditors: [],
  location: "",
  auditNumber: "",
  auditYear: "",
  auditName: "",
  date: "",
  auditObjective: "",
  scheduleDate: "",
  auditedEntity: "",
  auditees: [],
  auditTemplate: "",
  auditScheduleId: "No Schedule",
  auditedClauses: [{ item: {} }],
  auditedDocuments: [{ item: {} }],
  checklist: [],
  selectedTemplates: [],
  sections: [],
  goodPractices: "",
  systemDtls: [{ item: {} }],
  clause_refs: [],
  sop_refs: [],
  hira_refs: [],
  capa_refs: [],
  auditScope:"",
};
